import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ManageUserService extends BaseService{ 

  constructor() {
    super();
  }
  getAllUsers():Observable<any>{
  return this.httpService.get(APIUrl.userManage)
  }
  userUnlock(id){
    return this.httpService.postParams(`${APIUrl.userUnlock}/${id}`,'')
  }
  getUserbyId(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.userManage}/${id}`)
  }

  addNewUser(formData): Observable<any> {
    return this.httpService.post(APIUrl.userManage, formData)
  }
  updateUser(formData): Observable<any> {
    return this.httpService.put(APIUrl.userManage, formData)
  }
}
